import React, { memo, useMemo } from 'react';
import { connect } from 'react-redux';
import { axios, fetchInstance } from 'services';
import { Web5Provider } from '@Sage/ssm-web5';
import Context from 'managers/Context';
import { NEW_API_URL, B2_URL, FORCE_BI_URL, PATH_IMAGE } from 'constants/Environment';
import * as FmBridgeBackend from '@Sage/fm-bridge-backend';
import { logEvent } from 'utils/tracking';
import { getEntityFromString } from 'utils/getEntityFromString';
import { getDecimalsByConfig, formatDecimalByConfig, DECIMAL_TYPES } from 'utils/decimal';
import {
    COMPANIES,
    CONTACTS,
    OPPORTUNITIES,
    ACTIVITIES,
    AGENDA,
    SALESORDERS,
    DOCUMENTS,
    PRODUCTS,
    KPIS,
    BILLBOARD,
    CAMPAIGNS,
    CONVERSATIONS,
    METRICS,
    ANALYTICS_REPORT,
    DASHBOARD,
} from 'constants/Entities';
import { DEFAULT_THEME } from 'lib/metadata';

const Web5ProviderContext = ({ children, literals, theme = DEFAULT_THEME }) => {
    const providerProps = useMemo(
        () => ({
            children,
            context: {
                apiBaseURL: NEW_API_URL,
                axiosInstance: axios,
                b2URL: B2_URL,
                bridgeBackend: FmBridgeBackend,
                email: Context.config?.userData?.email,
                entities: {
                    ACTIVITIES,
                    AGENDA,
                    ANALYTICS_REPORT,
                    BILLBOARD,
                    CAMPAIGNS,
                    COMPANIES,
                    CONTACTS,
                    CONVERSATIONS,
                    DASHBOARD,
                    DOCUMENTS,
                    KPIS,
                    METRICS,
                    OPPORTUNITIES,
                    PRODUCTS,
                    SALESORDERS,
                },
                fetchInstance,
                forceBIURL: FORCE_BI_URL,
                getDecimalsByConfig,
                formatDecimalByConfig,
                DECIMAL_TYPES,
                getWeb4EntityFromString: getEntityFromString,
                implementation: parseInt(Context.config?.userData?.idImplementacion, 10),
                language: Context.config?.userData?.langISOInterface,
                locale: Context.config?.userData?.locale,
                locales: literals,
                logEvent,
                pathImage: PATH_IMAGE,
                platform: 101,
                token: Context.config?.token,
            },
            theme: theme || DEFAULT_THEME,
        }),
        [children, literals, theme],
    );
    return <Web5Provider {...providerProps} />;
};

const mapStateToProps = (state) => {
    return {
        literals: state.literal?.literals,
    };
};

export default memo(connect(mapStateToProps)(Web5ProviderContext));
